// <div data-controller="components--clipboard">
//     <div class="btn btn-primary"
//         id="copyAction"
//         data-target="components--clipboard.copyText"
//         data-clipboard-text="<%= "#{request.base_url}/#{current_user.username}" %>"
//         data-action="click->components--clipboard#onClickCopy">복사하기
//     </div>
// </div>
import { Controller } from "@hotwired/stimulus";
import ClipboardJS from 'clipboard';

export default class extends Controller {
  static targets = [ "copyText"];

  get flashesController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("flashesContainer"), "components--flashes")
  }

  connect() {
    this.clipboard = new ClipboardJS(this.copyTextTarget);
    this.clipboard.on("success", (e) => {
      const containsHTML = /<\/?[a-z][\s\S]*>/i.test(e.text); // HTML 태그 포함 여부 확인

      const message = containsHTML
          ? "선택하신 값이 클립보드에 복사되었습니다."
          : `<b>${e.text}</b> 값이 클립보드에 복사되었습니다.`;

      this.flashesController.createFlash({
        key: "check",
        ttl: 2,
        message: message,
        stack: false
      });
    });
  }


  disconnect() {
    this.clipboard.destroy()
  }
}